export const NATIONALITIES = [
  ['PE', 'Perú'], ['CO', 'Colombia'], ['EC', 'Ecuador'],
  ['VE', 'Venezuela'], ['BO', 'Bolivia'], ['CL', 'Chile'],
  ['AR', 'Argentina'], ['UY', 'Uruguay'], ['PY', 'Paraguay'],
  ['BR', 'Brasil'], ['MX', 'México'], ['ES', 'España'],
  ['US', 'Estados Unidos'], ['CA', 'Canadá'], ['FR', 'Francia'],
  ['IT', 'Italia'], ['DE', 'Alemania'], ['GB', 'Reino Unido'],
  ['CN', 'China'], ['JP', 'Japón'], ['OTHER', 'Otra'],
].map(([code, name]) => ({ code, name }));

export const nationalityLabel = (code) => {
  const item = NATIONALITIES.find((option) => option.code === code);
  return item ? item.name : code || '—';
};
